export default "__VITE_ASSET__CWr4vdWE__"